import FJVideoRemoveBgAutoLeft from '../view/FJVideoRemoveBgAutoLeft';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import FJActionVideoRemoveBg from '../../../../redux/action/FJActionVideoRemoveBg';
import { VIDEO_AUTO_REMOVE_BG_USE_CREDIT } from '../../../../redux/slices/FJSliceVideoBgRemover';
import PropTypes from 'prop-types';

const FJVideoRemoveBgAutoLeftContainer = ({ isShow }) => {
    const dispatch = useDispatch();

    const autoEditVideoIsUploading = useSelector(state => state.videoBgRemover.autoEditVideoIsUploading);
    const autoRemoverStatus = useSelector(state => state.videoBgRemover.autoRemoverStatus);
    const autoEditVideoInfo = useSelector(state => state.videoBgRemover.autoEditVideoInfo);
    const autoExportStatus = useSelector(state => state.videoBgRemover.autoExportData.exportStatus);
    const isTrimVideo = useSelector(state => state.videoBgRemover.autoRemoverIsTrimVideo);
    const videoAutoBackgroundRemoveFreeNum = useSelector(
        state => state.videoBgRemover.videoAutoBackgroundRemoveFreeNum,
    );
    const creditNumber = useSelector(state => state.common.creditNumber);

    const isFree = videoAutoBackgroundRemoveFreeNum > 0 && VIDEO_AUTO_REMOVE_BG_USE_CREDIT > creditNumber;

    const _uploadVideo = useCallback(
        file => {
            dispatch(FJActionVideoRemoveBg.uploadAutoEditVideoAction(file));
        },
        [dispatch],
    );

    const _uploadBeforeCallback = useCallback(() => {
        dispatch(FJActionVideoRemoveBg.pauseAction());
    }, [dispatch]);

    const _exportVideo = useCallback(() => {
        dispatch(FJActionVideoRemoveBg.autoExportVideoAction());
    }, [dispatch]);

    const _removeAll = useCallback(() => {
        dispatch(FJActionVideoRemoveBg.removeAllAction());
    }, [dispatch]);

    return (
        <FJVideoRemoveBgAutoLeft
            autoEditVideoIsUploading={autoEditVideoIsUploading}
            autoRemoverStatus={autoRemoverStatus}
            autoEditVideoInfo={autoEditVideoInfo}
            autoExportStatus={autoExportStatus}
            freeNumCreation={videoAutoBackgroundRemoveFreeNum}
            isFree={isFree}
            isTrimVideo={isTrimVideo}
            isShow={isShow}
            uploadVideo={_uploadVideo}
            uploadBeforeCallback={_uploadBeforeCallback}
            exportVideo={_exportVideo}
            removeAll={_removeAll}
        />
    );
};

FJVideoRemoveBgAutoLeftContainer.propTypes = {
    isShow: PropTypes.bool,
};

export default FJVideoRemoveBgAutoLeftContainer;
